import { post, request } from '../api';

/** Mirrors `apps/api/src/me/me.module.ts`. The panel never sees a whole chat id, only its last four. */
export interface TelegramLink {
  linked: boolean;
  chatIdSuffix?: string;
}

export interface TelegramLinkCode {
  /** Already grouped as `A7K2-M9QX`; the bot accepts it with or without the dash. */
  code: string;
  expiresAt: string;
}

export const meApi = {
  telegramLinkCode: () => post<TelegramLinkCode>('/me/telegram/link-code'),
  unlinkTelegram: () => request<TelegramLink>('/me/telegram', { method: 'DELETE' }),
};
